import apiService from '@/api/apiService';

/**
 * 成長系統 ↔ gonghao 會員對照
 * @param {object} params
 * @param {string} [params.q]
 * @param {string} [params.link_filter]
 * @param {number} [params.page]
 * @param {number} [params.page_size]
 */
export const getGrowthMemberLinks = (params = {}) =>
    apiService.GET('/api/admin/users/growth-links', params);

export const sendGrowthMemberLineProbe = (userId) =>
    apiService.POST(`/api/admin/users/${userId}/line-push-test`, {});
